export default __webpack_public_path__ + "static/media/head-pic.f1cdd1a2.png";